import { render, staticRenderFns } from "./PromoCodeScopeForm.vue?vue&type=template&id=060dac52"
import script from "./PromoCodeScopeForm.vue?vue&type=script&lang=ts"
export * from "./PromoCodeScopeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports